import { DatePicker, Pagination, Select } from "antd";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import { searchCmpBox } from "../../recoilatoms/searchCmp";
import AdminBoardService from "../../service/AdminBoardService";
import { formatDateToCustomString } from "../../util/changeDate";
import SearchInput from "../atom/SearchInput";
import TitleHeader from "../modecules/TitleHeader";
import TableList from "../table/TableList";

const AdminVocBoardWapper = styled.div`
  width: 60%;
  margin-top: 20px;
  position: relative;
`;

const AdminVocBoardSearchWrap = styled.div`
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: space-between;
  top: 90px;
`;

const { RangePicker } = DatePicker;

const AdminVocBoardPage = () => {
  const navigate = useNavigate();
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [filterboard, setfilterboard] = useState([]);
  const [progress, setProgress] = useState("4");
  const [page, setPage] = useState(currentPage);
  const [size, setSize] = useState(15);
  const [adminPassword, setAdiminPassword] = useState(sessionStorage.getItem("pw"));
  const [searchCmp, setSearchCmp] = useRecoilState(searchCmpBox);
  const [nameKeyword, setNameKeyword] = useState("");
  const [titleKeyword, setTitleKeyword] = useState("");
  const [empNmKeyword, setEmpNmKeyword] = useState("");
  const [totalLength, setTotalLength] = useState(20);
  // console.log(searchCmp);
  const [dates, setDates] = useState(null);
  const [value, setValue] = useState(null);
  // console.log('총 데이터 갯수', totalLength);
  // console.log('현재 페이지', page);
  // console.log('총 페이지 수 ', totalPages);
  // console.log('총 요소의 수 ', totalItemsCount);
  // console.log('배열로 나타낸 페이지 수', pageList);
  // console.log('떠있는 페이지', lookUpPageList);
  // console.log('한 페이지에 올라오는 데이터 수', size);
  // console.log("currentPage", currentPage);
  // console.log("location", location);
  // console.log(dataList);
  // rangePicker
  const disabledDate = (current) => {
    if (!dates) {
      return false;
    }
    const tooLate = dates[0] && current.diff(dates[0], "days") >= 365;
    const tooEarly = dates[1] && dates[1].diff(current, "days") >= 365;
    return !!tooEarly || !!tooLate;
  };
  const onOpenChange = (open) => {
    // console.log(open);
    if (open) {
      setDates([null, null]);
    } else {
      setDates(null);
    }
  };

  const rangPickerHandler = async (e) => {
    const formattedDate = formatDateToCustomString([e[0].$d, e[1].$d]);
    // console.log("formattedDate", formattedDate);
    // setFormatDate([formattedDate[0], formattedDate[1]]);

    const response = await AdminBoardService.getSearchRangeDate(formattedDate);
    // console.log("날짜 구성 배열", response.data.content);
    console.log("date searching....");
    setDataList(response.data.content);
  };

  useEffect(() => {
    if (!nameKeyword) {
      getDataList(nameKeyword);
    } else if (!titleKeyword) {
      getDataList(titleKeyword);
    } else if (!empNmKeyword) {
      getDataList(empNmKeyword);
    } else getDataList();
  }, [nameKeyword, titleKeyword, empNmKeyword]);

  const handleSearch = (searchText) => {
    if (searchCmp === "작성자") {
      console.log("작성자에 맞게 데이터 들어감", searchText);
      setNameKeyword(searchText);
      setTitleKeyword("");
      setEmpNmKeyword("");
    } else if (searchCmp === "제목") {
      console.log("제목에 맞게 데이터 들어감", searchText);
      setTitleKeyword(searchText);
      setNameKeyword("");
      setEmpNmKeyword("");
    } else if (searchCmp === "조치담당자") {
      setTitleKeyword("");
      setNameKeyword("");
      setEmpNmKeyword(searchText);
    } else {
      setTitleKeyword("");
      setNameKeyword("");
      setEmpNmKeyword("");
    }
  };

  const getDataList = async () => {
    const response = await AdminBoardService.getVocBoardList(
      page,
      size,
      adminPassword,
      progress,
      nameKeyword,
      titleKeyword,
      empNmKeyword
    );
    // console.log(response);
    if (response.status === "success" && response.data !== null) {
      setDataList(response.data.content);
      setfilterboard(response.data.content);
      setPage(page);
      setTotalLength(response.data.total);
    } else {
      navigate("/AdminVocLogin");
    }
  };

  useEffect(() => {
    //progress 0~4
    if (sessionStorage.getItem("isAdmin") === "true") {
      getDataList();
    } else {
      return;
    }
  }, [progress, page]);

  useMemo(() => {
    const filterBoard = dataList.filter((el) => {
      if (progress === "0" && el.accept === "0") {
        return dataList;
      } else if (progress === "1" && el.accept === "1") {
        return dataList;
      } else if (progress === "2" && el.accept === "2") {
        return dataList;
      } else if (progress === "3" && el.accept === "3") {
        return dataList;
      } else if (progress === "5" && el.accept === "5") {
        return dataList;
      } else if (
        progress === "4" &&
        (el.accept === "0" || el.accept === "1" || el.accept === "2" || el.accept === "3" || el.accept === "5")
      ) {
        return dataList;
      }
      return dataList;
    });

    setfilterboard(filterBoard);
  }, [dataList, progress]);

  const progressMenu = (e) => {
    // console.log(e);
    setProgress(e.value);
  };

  const onPageChange = (e) => {
    setPage(e - 1);
    setCurrentPage(page + 1);
  };

  return (
    <AdminVocBoardWapper>
      <AdminVocBoardSearchWrap>
        <RangePicker
          value={dates || value}
          disabledDate={disabledDate}
          onCalendarChange={(val) => {
            setDates(val);
          }}
          onChange={(val) => {
            setValue(val);
            rangPickerHandler(val);
          }}
          onOpenChange={onOpenChange}
          changeOnBlur
        />

        <Select
          style={{ width: 120 }}
          onChange={progressMenu}
          labelInValue
          defaultValue={{ value: "4", label: "전체" }}
          options={[
            {
              value: 4,
              label: "전체",
            },
            {
              value: 0,
              label: "대기",
            },
            {
              value: 1,
              label: "접수",
            },
            {
              value: 2,
              label: "보류",
            },
            {
              value: 3,
              label: "삭제",
            },
            {
              value: 5,
              label: "종료",
            },
          ]}
        ></Select>
      </AdminVocBoardSearchWrap>

      <TitleHeader title={"VOC 목록"} />
      <SearchInput onSearchHandler={handleSearch} />

      <TableList filterboard={filterboard} size={size} page={currentPage} setPage={setPage} />
      <Pagination
        onChange={(e) => onPageChange(e)}
        current={page + 1}
        pageSize={Number(size)}
        total={totalLength}
        showSizeChanger={false}
      />
    </AdminVocBoardWapper>
  );
};

export default AdminVocBoardPage;
